module.exports = __webpack_public_path__ + "img/xinghao.0a7906ac.png";